import { api } from "@/lib/api";

export const isImpersonating = () => !!localStorage.getItem("cop31_admin_token");

export async function startImpersonation(userId) {
  const { data } = await api.post(`/users/${userId}/impersonate`);
  localStorage.setItem("cop31_admin_token", localStorage.getItem("cop31_token"));
  localStorage.setItem("cop31_admin_return", window.location.pathname);
  localStorage.setItem("cop31_token", data.token);
  const routes = { customer: "/musteri/dashboard", supplier: "/tedarikci/dashboard", viewer: "/izleyici", assigner: "/atayici", uretici: "/uretici", taseron: "/taseron" };
  window.location.href = routes[data.user.role] || "/";
}

export function endImpersonation() {
  const adminToken = localStorage.getItem("cop31_admin_token");
  const back = localStorage.getItem("cop31_admin_return") || "/admin/dashboard";
  localStorage.removeItem("cop31_admin_token");
  localStorage.removeItem("cop31_admin_return");
  if (adminToken) localStorage.setItem("cop31_token", adminToken);
  window.location.href = back;
}
